

Greenmile.DataImport = Greenmile.DataImport || {};

Greenmile.DataImport.UploadFile = (function () {

    function DataImportUploadFile() {

        this.mappingTemplate = new Greenmile.DataImport.MappingTemplate();
        this.uploader = null;
        this.className = 'uploadSection';

        this.createBaseStructure = function() {

            this.rootEl = document.createElement('div');
            this.rootEl.className = this.className;

        };

        this.addEventToUploadFile = function(options) {
            this.uploader = new Greenmile.Components.FileUploader(options);
            this.uploader.render();
        };

        this.createUploadArea = function() {

            var container = document.createElement('div');
            container.className = 'uploadFile';

            var messages = document.createElement('div');
            messages.className = 'uploadMessages';

            var image = document.createElement('div');
            image.className = 'uploadImage';

            var button = document.createElement('button');
            var input = document.createElement('input');
            input.type = 'file';
            input.className = 'inputfile';
            button.innerHTML = Monet.I18n.getResourcesByKey('General.Upload');
            button.appendChild(input);

            var dragMessage = document.createElement('label');
            dragMessage.className = 'uploadDragMessage';
            dragMessage.innerHTML = Monet.I18n.getResourcesByKey('Greenmile.DataImport.dragMessage');
            
            image.addEventListener("click", function() {
                input.click();
            });

            button.addEventListener("click", function() {
                input.click();
            });

            container.appendChild(messages);
            container.appendChild(image);
            container.appendChild(button);
            container.appendChild(dragMessage);

            this.rootEl.appendChild(container);

            this.addEventToUploadFile({
                input: button,
                dropArea: container,
                successCallback: this.uploadSuccess,
                statusCallback: this.setUploadStatus,
                errorCallback: this.uploadError
            });

        };

        this.uploadSuccess = function(result) {
            var divStatus = document.querySelector(".uploadFile"),
                message = divStatus.querySelector('.uploadMessages'),
                icon = divStatus.querySelector('.uploadImage');
            if(result) {
                icon.className = 'uploadImage success';
                message.innerHTML = Monet.I18n.getResourcesByKey('Greenmile.DataImport.fileUploaded', result.primaryName);
                App.Forms.DataImport.uploadFile = result;
            }
            
        };

        this.uploadError = function(error) {
            var divStatus = document.querySelector(".uploadFile"),
                message = divStatus.querySelector('.uploadMessages'),
                icon = divStatus.querySelector('.uploadImage');
            message.innerHTML = '';
            Greenmile.DataImport.Utils.showErrorMessage(error.responseText);
            icon.className = 'uploadImage error';
        };

        this.setUploadStatus = function() {
            var divStatus = document.querySelector(".uploadFile"),
                message = divStatus.querySelector('.uploadMessages'),
                icon = divStatus.querySelector('.uploadImage');

            Greenmile.DataImport.Utils.clearErrorMessage();
            icon.className = 'uploadImage';
            message.innerHTML = Monet.I18n.getResourcesByKey('Greenmile.DataImport.UploadingFile');

        }.bind(this);

        this.show = function(view) {
            var container = document.querySelector('.form_DataImport');
            container.innerHTML = '';
            container.parentNode.setAttribute('screen', this.className);

            this.render(view);

            container.appendChild(this.rootEl );

            this.uploadSuccess(App.Forms.DataImport.uploadFile);

        };

        this.createAndAddTitle = function() {
            var title = document.createElement('div');
            title.className = 'title';
            title.innerHTML = Monet.I18n.getResourcesByKey('Greenmile.DataImport.UploadTitle');
            this.rootEl.appendChild(title);
        };

        this.processUpload = function() {

            var template = this.mappingTemplate.getValue();
            var typeImport = this.mappingTemplate.getTypeImportSelected();
            var uploadedFile = App.Forms.DataImport.uploadFile;
            Greenmile.DataImport.Utils.clearErrorMessage();

            if(!uploadedFile) {
                var response =  {
                                    errorMessages: [
                                      Monet.Form.Messages.mountErrorMessageObject('Greenmile.DataImport.noFileFound')]
                                };
                App.Objects.DataImport.createAndUpdateErrorHandler(response, null, "DataImport");

                return;
            }
            
            if (template === 'NEW') {

                Greenmile.DataImport.MappingScreenFactory.showMapScreen(uploadedFile);

                this.btnProcess.enable();
            } else {
                App.Objects.DataImport.processUploadedFile(App.Forms.DataImport.uploadFile, template, typeImport);
            }
        }.bind(this);

        this.getProcessButton = function() {
           this.btnProcess = new Monet.UI.Fields.Render({
               label: 'Greenmile.DataImport.btnProcess',
               type: 'BUTTON',
               name: 'btnProcess',
               customJavaScript: this.processUpload
            }).render();

            return this.btnProcess.rootEl;
        };

        this.render = function(view) {

            this.createBaseStructure();
            this.createAndAddTitle();

            this.rootEl.appendChild(view.entityPicklist.getRootEl());

            this.createUploadArea();

            this.rootEl.appendChild(this.mappingTemplate.render());
            this.rootEl.appendChild(this.getProcessButton());

            App.Forms.DataImport.MappingTemplate = this.mappingTemplate;

            return this.rootEl;
        };
    }

    return DataImportUploadFile;
}());